import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from "../../styles/Profile.module.scss";
import shared from "../../styles/UserProfileCommon.module.scss";
import ProfilePlanDetails from "../helpers/ProfilePlanDetails.tsx";
import { getAccountSubscription, getEligibleRenewal } from "../../selectors/currentAccountSelector";
import currentUserInfo from "../../selectors/currentUserInfo";
import { fetchAccountData } from "../../actions/account";
import Spinner from "../../components/Spinner";
import { logoSrcForProductName } from "../../pages/Home";

export default function UserSubscription(props) {
  const dispatch = useDispatch();
  const currentUser = useSelector(currentUserInfo);
  const subscription = useSelector(getAccountSubscription);
  const [isLoading, setIsLoading] = useState(true);
  const eligibleRenewal = useSelector(getEligibleRenewal);

  const spinnerStyle = {
    height: "50px",
    width: "50px",
  };

  async function fetchData() {
    await dispatch(fetchAccountData());
  }

  useEffect(() => {
    if (currentUser) {
      fetchData();
      setTimeout(() => {
        setIsLoading(false);
      }, 1200);
    }
    //eslint-disable-next-line
  }, [currentUser]);

  function renderPlanDetails() {
    if (subscription !== undefined) {
      return subscription.map((plan, index) => {
        return (
          <div key={index}>
            <ProfilePlanDetails
              icon={logoSrcForProductName(plan.product)}
              planName={plan.planName}
              // status={plan.status}
              // paymentOccurance={plan.billingInterval}
              // nextPayment={plan.nextPaymentDate}
              // paymentAmount={plan.paymentAmount}
              // seatQuantity={plan.seatQuantity}
              totalSeats={plan.devices ? plan.devices.length : 0}
              // billingInfo={plan.billingInfo}
              devices={plan.devices}
              // product={plan.product}
              // duplicateIds={plan.duplicateIds}
              eligibleRenewal={eligibleRenewal}
              productType={plan.product}
            />
            <hr className={shared.dividerLine} />
          </div>
        );
      });
    }
  }

  return (
    <div className={styles.profileWrapper}>
      <div>
        {isLoading ? (
          <div className={styles.spinnerWrapper}>
            <Spinner isLoading={isLoading} spinnerStyle={spinnerStyle} />
          </div>
        ) : (
          <div>
            <div className={styles.subHeader}>
              <h2>Plan Details</h2>
              <hr className={shared.dividerLine} />
              <div>{renderPlanDetails()}</div>
            </div>          
            {/* <div className={styles.subHeader}>
              <h2>Payment History</h2>
              <hr className={shared.dividerLine} />
              <ProfilePaymentHistory invoices={invoices} fullPage={false} />
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
}
